var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProductInventoryHeader',{attrs:{"img_header":_vm.header_image,"header":"แก้ไขสินค้าเข้าคลัง (Modify product into inventory)","link_back":"warehouse/productinventoryadd","status_btn":1}}),_c('Edit_product_re')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }